module.exports = __webpack_public_path__ + "img/planetary-rev05.3ba2f97f.gif";